import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnalyticsService } from '@geneplanet/ngx-utils';
import { first } from 'rxjs/operators';
import { LanguageService } from 'src/app/shared/services/language.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-language-switcher',
  templateUrl: './header-language-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLanguageSwitcherComponent {
  environment = environment;
  constructor(
    public languageService: LanguageService,
    private analyticsService: AnalyticsService
  ) {}

  locationChange(event: any) {
    this.languageService.onLocationChange(event);
    this.languageService.currentLocation$
      .pipe(first())
      .subscribe((location) => {
        const value = {
          value: location.lang.code + '/' + location.currency,
        };

        this.analyticsService.trackFormValue(
          'header-location-change',
          'location',
          value
        );
      });
  }
}
